export const alamo = {
    agencyCode: '009163',
    name: 'Alamo Colleges',
    shortName: 'Alamo',
    slug: 'alamo',
  };
  